var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image",class:_vm.classes},[_c('img',{staticClass:"is-rounded",attrs:{"src":_vm.avatar,"alt":_vm.alt},on:{"error":(e) => {
        _vm.loadDefault(e)
      }}})])
}
var staticRenderFns = []

export { render, staticRenderFns }